import "moment/locale/en-gb";
import React, { FC, useEffect } from "react";
import "react-dates/lib/css/_datepicker.css";
import "@styles/form.css";
import {
  FormBase,
  FormProps,
  InputDescription,
  InputName,
} from "@components-common/forms";
import { Parameter } from "./types/parameter";
import { ParameterValueInputByType } from "./ParameterValueInputByType";
import { ParameterTypeRandom } from "./ParamaterTypeRandom";
import { Col } from "taltech-styleguide";

export const ParameterForm: FC<
  FormProps<Parameter> & { isParameterRandom: boolean }
> = ({ ...props }) => {

  const body = (
    <FormBase {...props}>
      <Col xs="12" md="7">
        <InputName showHelp={false} />
        {props.isParameterRandom ? (
          <ParameterTypeRandom />
        ) : (
          <ParameterValueInputByType />
        )}
        <InputDescription showHelp={false} elementClass="mt-2" />
      </Col>
    </FormBase>
  );
  return body;
};
